import { useEffect, useState } from "react";

export type Theme = "dark" | "light";

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => (
    document.documentElement.dataset.theme === "light" ? "light" : "dark"
  ));

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("handlequest-theme", theme);
  }, [theme]);

  return {
    theme,
    toggleTheme: () => setTheme((current) => current === "dark" ? "light" : "dark")
  };
}

